import { useAuth } from './use-auth';
import { useWallet } from './use-wallet';
import { useModelStore } from '@/client/store/model-store';
import { useTradeResumeStore } from '@/client/store/trade-resume-store';
import { useTradeParamsStore } from '@/client/store/trade-store';
import { useEffect } from 'react';
import { useLocation, useSearch } from 'wouter';

export const useTradeLoginResume = () => {
  const { lastLoginResult, isAuthLoading } = useAuth();
  const { connectModalOpen } = useWallet();
  const authOpen = useModelStore(state => state.authOpen);
  const draft = useTradeResumeStore(state => state.suspendedTrade);
  const [pathname] = useLocation();
  const search = useSearch();
  const route = pathname + (search ? `?${search}` : '');

  useEffect(() => {
    if (!draft) return;
    if (draft.route !== route) {
      useTradeResumeStore.getState().discardSuspendedTrade();
      return;
    }
    if (isAuthLoading || connectModalOpen || authOpen || lastLoginResult?.attemptId !== draft.attemptId) return;
    const saved = useTradeResumeStore.getState().takeSuspendedTrade(lastLoginResult.attemptId, route);
    if (!saved) return;
    useTradeParamsStore.getState().setTradeParams(saved.params);
    useTradeResumeStore
      .getState()
      .setResumeNotice(lastLoginResult.outcome === 'success' ? undefined : lastLoginResult.outcome);
    useModelStore.getState().setTradeOpen(true);
  }, [authOpen, connectModalOpen, draft, isAuthLoading, lastLoginResult, route]);
};
